import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import { createApp } from 'vue'
import App from './App.vue';
import router from './router';
import axios from 'axios';
import VueAxios from 'vue-axios';
import bootstrap from 'bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import '@/assets/style.css';

//import 'devextreme/dist/css/dx.light.css';
//import 'devextreme/dist/css/dx.light.compact.css';
import 'devextreme/dist/css/dx.material.blue.light.css';

const _app = createApp(App);

/* Local */
//_app.config.globalProperties.apiUrl = "http://localhost:7071/api/";

/* Live */
_app.config.globalProperties.apiUrl = "https://fleetcareconfigurator.azurewebsites.net/api/";

/* Test */
//_app.config.globalProperties.apiUrl = "https://fleetcareconfiguratortest.azurewebsites.net/api/";

_app.config.globalProperties.loadingIndicatorUrl = "https://requisite-solutions.com/wp-content/uploads/2022/04/loading.gif";

_app
    .use(router)
    .use(VueAxios, axios)
    .use(bootstrap);
  
router.App = _app;

_app.mixin({
    methods: {  
        login(data, callback) {
            this.post(this.apiUrl + 'users/authenticate', data, (response) => {
                callback(response);
            });
            

            //this.post(this.apiUrl + 'users/authenticate', data, (response) => {
            //    callback(response);
            //});
            /*
            .then((response) => {
                
                //console.log(response.data);
                
                this.storeUserData(response.data);
                this.$emit('loggedIn')                           
                if(this.$route.params.nextUrl != null){
                    this.$router.push(this.$route.params.nextUrl)
                }
                else {
                    this.$router.push('home')                            
                }  
            */
            return "";
        },    
        storeUserData: function(data) {
           
            localStorage.clear();
            localStorage.setItem('contactId', data.ContactId);
            localStorage.setItem('hasAcceptedQuote', data.HasAcceptedQuote);
            localStorage.setItem('tennantId', data.TennantId);
            localStorage.setItem('organisationId', data.OrganisationId);
            localStorage.setItem('settings', JSON.stringify(data.Settings));
            localStorage.setItem('userToken', data.Token);
            localStorage.setItem('userEmail', data.Email);
            localStorage.setItem('userName', data.Name);
            localStorage.setItem('permissions', JSON.stringify(data.Permissions));  
            localStorage.setItem('filters',JSON.stringify(data.Filters));
            localStorage.setItem('filterValues',JSON.stringify(data.FilterValues))

            //this.getFilters();

            if(data.Settings.StyleSheet) {
                //localStorage.setItem('styleSheet', response.data.StyleSheet);
                this.addStyleSheet(data.Settings.StyleSheet);
            }
        }, 
        getPermissions: function(entityName) { 
            var permissions = JSON.parse(localStorage.getItem('permissions'));
            var permission = permissions.filter(p => p.EntityName == entityName);
            if(permission.length > 0)
            {
                return permission[0];
            }
            else
            {
                return { Name: entityName, Create: false, Read: false, Update: false, Delete: false };
            }
        },
        userIsGlobalAdmin() {
            return this.getPermissions("Tennant").Create;            
        },
        setViewAsContactId(id) {
            localStorage.setItem('_contactId',localStorage.getItem('contactId'));
            localStorage.setItem('contactId', id);
        },
        clearViewAsContactId() {
            localStorage.setItem('contactId',localStorage.getItem('_contactId'));
        },
        getHeaders: function() {
            return {
                'Content-type': 'application/json', 
                'token': this.getUserToken(),
                'x-functions-key': this.getAPIKey()
            };
        },
        getUserToken() {
            return localStorage.getItem('userToken');
        },
        getAcceptedQuoteId() {
            return localStorage.getItem('acceptedQuoteId');
        },
        setAcceptedQuoteId(value) {
            localStorage.setItem('acceptedQuoteId', value);
        },
        getQuoteAcceptedText() {
            return this.getSetting('AcceptedQuoteText'); //localStorage.getItem('acceptedQuoteText');
        },
        setQuoteAcceptedText(value) {
            localStorage.setItem('acceptedQuoteText', value);
        },
        getSettings() {
            var settings = localStorage.getItem('settings');
            if(settings) {
                return JSON.parse(settings);
            }
        },
        getSetting(name) {
            var settings = this.getSettings();
            if(settings && (name in settings)) {
                return settings[name];
            }
        },
        setSetting(name,value) {
            var settings = this.getSettings();
            if(settings) {
                settings[name] = value;
                localStorage.setItem('settings', JSON.stringify(settings));
            }
        },
        getAPIKey() {
            //return localStorage.getItem('apiKey');
            return this.getSetting('APIKey');
        },
        getCombinedKey() {
            return btoa(this.getUserToken() + ':' + this.getAPIKey());
        },
        getArray(obj) {
            return Array.isArray(obj) ? obj : [obj];
        },
        addStyleSheet(css) {
            var style = document.createElement('style');
            style.type = 'text/css';
            style.appendChild(document.createTextNode(css));
            document.head.appendChild(style);
        },
        /*cacheSchemas() {
            this.$http.get(this.apiUrl + 'schemas',
            {
                headers: this.getHeaders()
            })
            .then((response) => {                            
                localStorage.setItem('schemas',JSON.stringify(response.data));
            }, (error) => {
                
            });  
        },*/
        getContactFilters() {
            var filters = localStorage.getItem('filters');
            if(filters) {
                return JSON.parse(filters);
            }
        },
        getFilters: function(callback) {
            var filterValues = localStorage.getItem('filterValues');
     
            if(!filterValues) {
                this.get(this.apiUrl + 'filters/values', (data) => {
                    localStorage.setItem('filterValues', JSON.stringify(data));  

                    data = this.applyContactFilters(data);

                    if(callback)
                        callback(data);
                });
            } else {               
                var data = JSON.parse(filterValues);

                data = this.applyContactFilters(data);

                if(callback)
                    callback(data);
            }
        },
        applyContactFilters(filterValues) {
            var contactFilters = this.getContactFilters();
            if(!(contactFilters))
                return filterValues;
    
            Object.keys(contactFilters).forEach(key => {
                  var filter = filterValues.find(f => f.Key == key);
                  if(filter) {
                    filter.Value = contactFilters[key];
                    filter.Locked = true;
                  }
                });
            
            return filterValues;
        },
        getSchemas: function(callback) {
            var schemas = localStorage.getItem('schemas');
     
            if(!schemas) {
                this.get(this.apiUrl + 'schemas', (data) => {
                    localStorage.setItem('schemas', JSON.stringify(data));  
                    callback(data);
                });
            } else {               
                callback(JSON.parse(schemas));
            }
        },
        get(url, callback) {
            this.$http.get(url, 
            {
                headers: this.getHeaders()
            })
            .then((response) => {        
                if(callback) {
                    callback(response.data);                         
                }
            }, (error) => {
                callback(error);
            });
        },
        post(url, data, callback) {
            this.$http.post(url, data,
            {
                headers: this.getHeaders()
            })
            .then((response) => {        
                if(callback) {
                    callback(response.data);                         
                }
            }, (error) => {
                callback(error);                
            }); 
        },
        put(url, data, callback) {
            this.$http.put(url, data,
            {
                headers: this.getHeaders()
            })
            .then((response) => { 
                if(callback) {       
                    callback(response.data);                         
                }
            }, (error) => {
                callback(error);
            }); 
        },
        delete(url, callback) {
            this.$http.delete(url,
            {
                headers: this.getHeaders()
            })
            .then((response) => { 
                if(callback) {       
                    callback(response.data);                         
                }
            }, (error) => {
                callback(error);
            }); 
        },
        objectEquals(x, y) {
          
            if (x === null || x === undefined || y === null || y === undefined) { return x === y; }
            // after this just checking type of one would be enough
            if (x.constructor !== y.constructor) { return false; }
            // if they are functions, they should exactly refer to same one (because of closures)
            if (x instanceof Function) { return x === y; }
            // if they are regexps, they should exactly refer to same one (it is hard to better equality check on current ES)
            if (x instanceof RegExp) { return x === y; }
            if (x === y || x.valueOf() === y.valueOf()) { return true; }
            if (Array.isArray(x) && x.length !== y.length) { return false; }
        
            // if they are dates, they must had equal valueOf
            if (x instanceof Date) { return false; }
        
            // if they are strictly equal, they both need to be object at least
            if (!(x instanceof Object)) { return false; }
            if (!(y instanceof Object)) { return false; }
        
            var objectEquals = this.objectEquals;

            // recursive object equality check
            var p = Object.keys(x);
            return Object.keys(y).every(function (i) { return p.indexOf(i) !== -1; }) &&
                p.every(function (i) { return objectEquals(x[i], y[i]); });
        },        
        isObject(obj) {
            return typeof obj === 'object' && obj !== null
        },
        isArray(obj) {
            return Array.isArray(obj);
        },
        formatDate(dateStr) {
            if(!(dateStr) || dateStr.length == 0)
                return '';
            return new Date(dateStr).toLocaleDateString('en-GB');  
        },
        imageExists(url){
            if(!(url))
                return false;

            var image = new Image();
            image.src = url;
            if (!image.complete) {
                return false;
            }
            else if (image.height === 0) {
                return false;
            }
        
            return true;
        }
    }
});    

_app.mount('#app');


